import { Swiper } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import { Box } from "@mui/material";
import { useBreakpoints } from "../../context/provider/BreakpointsProvider";

const ReactSwiper = ({ children, swiperRef, onSwiper, sx, ...rest }) => {
  const { upSm } = useBreakpoints();

  return (
    <Box
      component={Swiper}
      ref={swiperRef}
      sx={sx}
      modules={[Navigation, Pagination, Scrollbar, A11y]}
      spaceBetween={50}
      slidesPerView={upSm ? 2 : 1}
      width={1}
      onInit={(swiper) => {
        swiper.navigation.init();
        swiper.navigation.update();
      }}
      navigation={{
        prevEl: ".prev-arrow",
        nextEl: ".next-arrow",
      }}
      onSwiper={onSwiper}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default ReactSwiper;
